module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/36b78bbefbadfa3a0557ec22c3fed5a6.png";